import { jsxs as c, jsx as o } from "react/jsx-runtime";
import { useBreakpointValue as d, useMultiStyleConfig as m, Flex as s, Box as n } from "@chakra-ui/react";
import { GlobalFooterCopyright as p } from "./GlobalFooterCopyright.mjs";
const x = ({
  copyright: i,
  links: r,
  socials: t,
  ...l
}) => {
  const e = d({ base: !0, md: !1 }, { fallback: "md" }), a = m("GlobalFooter");
  return /* @__PURE__ */ c(
    s,
    {
      sx: a.mainContainer,
      p: e ? 4 : 10,
      flexDirection: e ? "column" : "row",
      rowGap: e ? 4 : 6,
      justifyContent: t && r ? "space-between" : "center",
      ...l,
      children: [
        r && /* @__PURE__ */ o(n, { order: 1, ...e && { width: "100%" }, children: r }),
        /* @__PURE__ */ o(n, { order: e ? 3 : 2, children: /* @__PURE__ */ o(p, { copyright: i }) }),
        t && /* @__PURE__ */ o(n, { order: e ? 2 : 3, children: t })
      ]
    }
  );
};
export {
  x as GlobalFooterMainContainer
};
